function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4102 10.1304C13.2851 9.9764 13.0751 9.91947 12.8903 9.98573C12.3723 10.1715 11.8104 10.2667 11.2187 10.2667C8.38788 10.2667 6.08535 7.9632 6.08535 5.13333C6.08535 3.43 6.92628 1.84427 8.33468 0.8904C8.49428 0.782133 8.57082 0.587067 8.52788 0.399467C8.48495 0.211867 8.33095 0.07 8.13962 0.042C7.92122 0.0102667 7.70375 0 7.48535 0C3.62508 0 0.485352 3.13973 0.485352 7C0.485352 10.8603 3.62508 14 7.48535 14C9.93535 14 12.1642 12.7549 13.4456 10.6699C13.5492 10.5009 13.5343 10.2853 13.4102 10.1304Z",
  fill: "#D18F1F"
});
function SvgNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.0fcbe120798065bcf0537dc6a7ffe3ff.svg";
export { ForwardRef as ReactComponent };